module.exports = __webpack_public_path__ + "static/ec-49b029935f1fed2c2a61e445c24fb59b.jpg";